import axios from "axios";

export const handlingApi = async ({ url, method, data, token=""}) => {
  try {
    const response = await axios({
      url,
      method,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      withCredentials: true,
      data,
    });

    return response.data; 
  } catch (error) {
    throw error;
  }
};
